export default "__VITE_ASSET__B$h3yPLd__"